import { css } from '@primeuix/themes';

import { createMenuTokens } from '../tokens/components.js';
import { SEMANTIC, type SemanticTokens } from '../tokens/semantic.js';

/**
 * Menu Component Configuration
 * Panel styled as overlay (matches select/multiselect overlay).
 * Items styled to match multiselect options.
 */
export function createMenu(s: SemanticTokens) {
  const menuTokens = createMenuTokens(s);
  return {
    root: {
      background: menuTokens.bg,
      borderColor: menuTokens.border,
      borderRadius: menuTokens.radius,
      color: menuTokens.fg,
      shadow: menuTokens.shadow,
      transitionDuration: menuTokens.transition,
    },
    list: {
      // padding: menuTokens.listPadding,
      // gap: menuTokens.listGap,
    },
    item: {
      focusBackground: menuTokens.item.bgFocus,
      selectedBackground: menuTokens.item.bgSelected,
      selectedFocusBackground: menuTokens.item.bgSelected,
      color: menuTokens.item.fg,
      focusColor: menuTokens.item.fgFocus,
      selectedColor: menuTokens.item.fgSelected,
      selectedFocusColor: menuTokens.item.fgSelected,
      padding: `${menuTokens.item.padding} ${menuTokens.item.padding}`,
      borderRadius: menuTokens.item.borderRadius,
      gap: menuTokens.item.gap,
      icon: {
        color: menuTokens.item.iconFg,
        focusColor: menuTokens.item.iconFgFocus,
      },
    },
    submenuLabel: {
      background: 'transparent',
      color: menuTokens.submenuLabel.fg,
      fontWeight: menuTokens.submenuLabel.fontWeight,
      padding: `${menuTokens.item.padding} ${menuTokens.item.padding}`,
    },
    separator: {
      borderColor: menuTokens.separator.border,
    },
    colorScheme: {
      light: {
        root: {
          background: menuTokens.bg,
          borderColor: menuTokens.border,
          color: menuTokens.fg,
        },
        item: {
          focusBackground: menuTokens.item.bgFocus,
          selectedBackground: menuTokens.item.bgSelected,
          selectedFocusBackground: menuTokens.item.bgSelected,
          color: menuTokens.item.fg,
          focusColor: menuTokens.item.fgFocus,
          selectedColor: menuTokens.item.fgSelected,
          selectedFocusColor: menuTokens.item.fgSelected,
        },
      },
    },
    css: () => `
    .p-menu {
      min-width: 8.625rem;
    }
  `,
  };
}
export const menu = createMenu(SEMANTIC);
